import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import Affiliate from '../pages/affiliate/page';
import TermsOfService from '../pages/terms-of-service/page';
import PrivacyPolicy from '../pages/privacy-policy/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/affiliate',
    element: <Affiliate />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfService />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
